import React, { useState } from 'react';
import './SupportPages.css';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: API 연동
    console.log('Contact form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 3000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="support-page">
      <div className="container">
        <div className="support-header">
          <h1 className="section-title">문의하기</h1>
          <p className="section-subtitle">
            궁금하신 사항이나 건의사항을 남겨주세요
          </p>
        </div>

        <div className="contact-container">
          <div className="contact-info">
            <h3>연락처 정보</h3>
            <div className="info-items">
              <div className="info-box">
                <div className="info-icon">📞</div>
                <div className="info-details">
                  <h4>전화</h4>
                  <p>02-6052-1192</p>
                  <small>평일 09:00 - 18:00</small>
                </div>
              </div>

              <div className="info-box">
                <div className="info-icon">📧</div>
                <div className="info-details">
                  <h4>이메일</h4>
                  <p>support@seoul-soft.com</p>
                  <small>24시간 접수 가능</small>
                </div>
              </div>

              <div className="info-box">
                <div className="info-icon">📠</div>
                <div className="info-details">
                  <h4>팩스</h4>
                  <p>02-600-9349</p>
                </div>
              </div>

              <div className="info-box">
                <div className="info-icon">🏢</div>
                <div className="info-details">
                  <h4>본사 / 연구소</h4>
                  <p>충청북도 충주시 중앙로 80</p>
                  <p>(네오메디클리닉), 501호</p>
                </div>
              </div>

              <div className="info-box">
                <div className="info-icon">🏢</div>
                <div className="info-details">
                  <h4>서울사무소</h4>
                  <p>서울특별시 금천구 가산디지털1로 84</p>
                  <p>810호</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h3>문의 양식</h3>
            {submitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h4>문의가 접수되었습니다</h4>
                <p>빠른 시일 내에 답변드리겠습니다.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">이름 *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-input"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">이메일 *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-input"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">문의 유형 *</label>
                  <select
                    id="subject"
                    name="subject"
                    className="form-input"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">선택해주세요</option>
                    <option value="service">서비스 이용 문의</option>
                    <option value="payment">요금/결제 문의</option>
                    <option value="technical">기술 지원</option>
                    <option value="partnership">제휴 문의</option>
                    <option value="etc">기타</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">문의 내용 *</label>
                  <textarea
                    id="message"
                    name="message"
                    className="form-textarea"
                    rows={6}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-lg">
                  문의하기
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
